// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__SNkkn","jpCurrentDate":"JP_Footer_jpCurrentDate__R5dVZ","jpFootage":"JP_Footer_jpFootage__X12e6","higlight":"JP_Footer_higlight__RVVHS"};